<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
}
</script>

<style>

@font-face { font-family: 'NotoSansKR';
  font-display: auto;
  font-style: normal;
  font-weight: 400;
  src: 	url(./assets/font/NotoSansKR-Regular.woff2) format('woff2'),
        url(./assets/font/NotoSansKR-Regular.woff) format('woff'),
        url(./assets/font/NotoSansKR-Regular.otf) format('opentype'); }



@font-face { font-family: 'NotoSansKR';
  font-display: auto;
  font-style: normal;
  font-weight: 700;
  src: 	url(./assets/font/NotoSansKR-Medium.woff2) format('woff2'),
        url(./assets/font/NotoSansKR-Medium.woff) format('woff'),
        url(./assets/font/NotoSansKR-Medium.otf) format('opentype'); }
html {
  //min-height: fit-content !important;
}

body{
  font-family: 'Noto Sans KR',sans-serif !important;
  font-weight: 400 !important;
  //min-height: fit-content !important;
}
.bg-hmm {
  background-color: #4fb1ec !important;
  border-color: #4fb1ec !important;
}
.btn-primary {
  background-color: #4fb1ec !important;
  border-color: #4fb1ec !important;
}
.btn-outline-primary {
  border-color: #4fb1ec !important;
  color: #0d6efd !important;
}
.btn-outline-primary:hover {
  border-color: #4fb1ec !important;
  background-color: #ffffff !important;
  color: #0d6efd !important;
}
.btn-dark {
  background-color: #87ceeb !important;
  border-color: #87ceeb !important;
  color: #0e3e52 !important;
  /*font-weight: bold !important;*/
}
.btn-cancel {
  background-color: #f2f2f2 !important;
  color: #b3b3b3 !important;
}
.required-field::after {
  content: '*';
  color: red;
  margin-left: 5px; /* 별표와 요소 사이의 간격 조정 */
  font-weight: bold; /* 별표를 굵게 표시 */
}
.label-container {
  position: relative;
}
.label-text {
  position: absolute;
  bottom: -1rem; /* 원하는 위치로 조정하세요. */
  left: 0;
  color: #888; /* 원하는 색상으로 설정하세요. */
  font-size: 0.75rem; /* 원하는 글꼴 크기로 설정하세요. */
}
.fs-label {
  font-size:1rem !important
}
.w-label{
  width: 30% !important;
  padding-left: 0px !important;
}
.w-input{
  width: 70% !important;
}
.fs-input{
  font-size: 1rem !important;
}
.fs-input-long{
  fs-input: 0.75rem !important;
}
.form-control {
  border: none !important;
  border-bottom: 1px solid #ccc !important;
  border-radius: 0 !important;
}
.form-control:focus {
  border-color: #80bdff !important;
  border-width: 2px !important;
  box-shadow: none !important;
}
/* 추가한 사용자 정의 CSS */
.custom-input-group .form-control {
  border: none;
  border-bottom: 2px solid #ccc;
  border-radius: 0; /* round 클래스를 제거하여 라운드를 없앱니다. */
}
.custom-input-group .form-control:focus {
  border-color: #80bdff;
  box-shadow: none;
}

.custom-input-group .input-group-text {
  border: none;
  border-bottom: 1px solid #ccc;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-width: 2px;
}

.signature-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  margin: 0 auto;
}
.signature-canvas-element {
  aspect-ratio: 350/150;
  border: 1px solid #ccc;
  margin-bottom: 10px;
}
body, html{
  margin: 0;
  padding: 0;
  min-height: 100vh;
}
section {
  flex: 1;
}
/* footer의 스타일 */
.footer {
  flex-shrink: 0; /* Footer does not shrink, always stays at its natural height */
  padding: 10px;
}
input[type="radio"] {
  /* Hide default radio button */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc !important;
  border-radius: 50%;
  outline: none;
  margin-right: 5px;
}
input[type="radio"]:checked {
  background-color: #4fb1ec;
  border-color: #4fb1ec;
  color: #fff;
}
[type="checkbox"] {
  width: 1.3em;
  height: 1.3em;

  border: 2px solid #ccc !important;
}
[type="checkbox"]:checked {
  background-color: #4fb1ec !important;
  border-color: #4fb1ec !important;
}
hr {
  border-width: 2px !important;
}
.width-2px {
  border-width: 2px;
}
.fs-title {
  //font-size: calc(1.2rem + .9vw)!important;
  font-size: 1.4rem;
}
.fs-nav {
  //font-size: calc(1.1rem + .9vw)!important;
  //max-font-size: 20px;
  font-size: 1.2rem;
}
.fs-info {
  font-size: calc(0.9rem + .9vw)!important;
}
.custom-checkbox {
  /* 선 두께를 변경하려면 border-width 속성을 조정합니다. */
  border-width: 2px; /* 원하는 두께로 수정하세요 */

  /* 다른 스타일 속성들을 추가로 조정할 수 있습니다. */
  border-color: #007bff; /* 원하는 색상으로 수정하세요 */
  border-radius: 4px; /* 원하는 둥근 모서리 정도로 수정하세요 */
}
input::placeholder {
  color: #b0b0b0 !important;/* 원하는 색상으로 수정하세요 */
}
.fs-comment {
  font-size: 1rem;
  opacity: 0.8;
}
.tel-link {
  text-decoration: none;
  font-size: 1.3rem;
  display: block;
  margin-top: 10px;
}
.focus-no:focus {
  outline: none !important;
  box-shadow: none !important;
}
</style>
